<template>
    <div>
      <Header :title="title"/>
      <div class="footer_podat" >
       <div class="main">
        <div align="center"><button class="btns" @click="dale()">Продолжить</button></div>
       </div>
    </div>
  
      <div class="content_podat">

      <div>
        <span>Если хотите обменять свою машину на другую, выберите один или несколько вариантов машин, которые хотите обменять.<br/>Если не хотите — просто нажмите «Продолжить».</span>
      </div>
      <table width="100%">
        <tr>
            <td><div class="clear" @click="clear()"><span>Сброс</span></div></td>
            <td align = "right"><button class="btnss" @click="addvariant()">Добавить варианты</button></td>
        </tr>
      </table>
      <br/>
      <div class="item" v-for="(item, index) in splitString" :key="index">
         {{ item }}
      </div>

      </div>
    </div>
  </template>
  
  <script>
  import Header from '../components/headerpodat'
  export default {
     components:{
     Header
     },
    data() {
      return {
        title:"Вариант обмена",
        obmen:"",
        arr:[],
      };
    },
    methods: {
      select() {
       
        

        this.$store.commit("addpodatobmen",this.obmen);
        this.$store.commit("addpodatobmentext",this.obmen_text);
         
  
      },

      addvariant(){
        localStorage.setItem("statusobmen","obmen");
        this.$router.push({ name: "kategObmen" });
      },
      clear(){
        this.$store.commit("addpodatobmen","");
        this.$store.commit("addpodatobmentext","");
        this.obmen="";
      },
      dale() {
        this.$router.push({ name: "foto" });
       
      },
      
    },
    computed: {
       getobmentext() {
        return this.$store.getters.getpodatobmentext;
      },
      splitString() {
      return this.obmen.split('+');
    },
     },

    mounted (){
        if(this.getobmentext){
        this.obmen=this.getobmentext;
        }
        
        
        localStorage.removeItem("obmen_kateg");
        localStorage.removeItem("obmen_kateg_text");
        localStorage.removeItem("obmen_razdel");
        localStorage.removeItem("obmen_razdel_text");
        localStorage.removeItem("obmen_marka");
        localStorage.removeItem("obmen_marka_text");
        localStorage.removeItem("obmen_model");
        localStorage.removeItem("obmen_model_text");
        localStorage.removeItem("obmen_tip");
        localStorage.removeItem("obmen_tip_text");
        localStorage.removeItem("obmen_god");
        localStorage.removeIte("statusobmen");
        
        
    },
    created() {
        if (!localStorage.getItem("token")) {
        this.$router.go(-1); 
        } 
    },
    
  
  };
  </script>
  <style scoped>
  .block_radio {
    margin-bottom: 1.4em;
  }
  .divgorod {
    width: 100%;
    color: #777777;
  }
  .contentgorod {
    font-size: 20px;
    border-bottom: 1px solid #000000;
    padding: 5px 5px 5px 0px;
  }
  label {
    font-size: 18px;
    width: 100%;
  }
  .content_podat {
    padding: 90px 5px 65px 10px;
  }
  .clear span{
    color:red;
  }
  .item{
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #444;

  }
  </style>